<template>
  <nav class="block mb-4 text-xs">
    <ol class="breadcrumb-list">
      <li class="breadcrumb-item">
        <router-link :to="{ name: 'index' }" class="hover:underline">首頁</router-link>
      </li>
      <li class="breadcrumb-item" v-if="$route.name === 'magazine'">
        <a>當月雜誌</a>
      </li>
      <!-- 館別 -->
      <li class="breadcrumb-item" v-if="$route.name !== 'magazine' && $route.name !== 'sale'">
        <router-link :to="{ name: navBarList.routerName, params:{ category: navBarList.category }, query: { type: navBarList.type } }" class="hover:underline">
          {{ navBarList.title }}</router-link>
      </li>
      <!-- 雜誌類別 -->
      <li class="breadcrumb-item" v-if="magType && $route.params.category === 'magazine'">
        <router-link :to="{ name: 'productsList', params:{ category: navBarList.category }, query: { scope: '', type: navBarList.type, category:  magType.category_id } }" class="hover:underline">
          {{ magType.title }}</router-link>
      </li>
      <!-- 雜誌訂閱類別 -->
      <li class="breadcrumb-item" v-if="magPlanType && $route.name !== 'magazine' && $route.name !== 'sale'">
        <a>{{ magPlanType.title }}</a>
      </li>
      <!-- 叢書館 -->
      <li class="breadcrumb-item" v-if="bookPlanType && $route.name !== 'magazine' && ($route.query.type === 'BOOK' || $route.query.type === 'BOOK,DIGITAL') && $route.name !== 'sale'">
        <a>{{ bookPlanType.title }}</a>
      </li>
      <!-- 套書館 -->
      <li class="breadcrumb-item" v-if="packagePlanType && $route.name !== 'magazine' && ($route.query.type === 'PACKAGE' || $route.query.type === 'ITEM') && $route.name !== 'sale'">
        <router-link :to="{ name: 'productsList', params:{ category: 'package' }, query: { type: 'PACKAGE', scope: packagePlanType.scope } }" class="hover:underline">{{ packagePlanType.title }}</router-link>
      </li>
      <li class="breadcrumb-item" v-if="packsgeCildType && $route.name !== 'magazine' && $route.query.type === 'PACKAGE' && $route.name !== 'sale'">
        <a>{{ packsgeCildType.title }}</a>
      </li>

      <!-- 數位學習 -->
      <li class="breadcrumb-item" v-if="$route.name !== 'magazine' && $route.name !== 'sale' && $route.query.digiType && $route.query.digiType === 'APP'">
        <a>APP學習</a>
      </li>
      <li class="breadcrumb-item" v-if="$route.name !== 'magazine' && $route.name !== 'sale' && $route.query.digiType && $route.query.digiType === 'EBOOK'">
        <a>電子書</a>
      </li>

      <!-- 詳細頁名稱 -->
      <li class="breadcrumb-item" v-if="$route.name === 'detail' && productTitle && $route.name !== 'magazine' && $route.name !== 'sale' && productTitle.category_name">
        <router-link :to="{ name: 'productsList', params:{ category: magParams.toLowerCase() }, query: { type: productTitle.type, category:  productTitle.category_id } }" class="hover:underline">
        {{ productTitle.category_name }}</router-link>
      </li>
      <li class="breadcrumb-item" v-if="$route.name === 'detail' && productTitle && $route.name !== 'magazine' && $route.name !== 'sale' && productTitle.name">
        <a>{{ productTitle.name }}</a>
      </li>
      <!-- 活動頁 -->
      <li class="breadcrumb-item" v-if="$route.name === 'sale'">
        <a>{{ productTitle.name }}</a>
      </li>
    </ol>
  </nav>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
export default {
  name: 'Breadcrumb',
  data () {
    return {
      menuData: [
        { title: '最新優惠', routerName: 'productsList', category: 'recent' },
        { title: '雜誌館', routerName: 'magazine', category: 'magazine', type: 'MAGAZINE' },
        { title: '叢書館', routerName: 'productsList', category: 'book', type: 'BOOK' },
        { title: '套書館', routerName: 'productsList', category: 'package', type: 'PACKAGE' },
        { title: '套書館', routerName: 'productsList', category: 'item', type: 'PACKAGE' },
        { title: '點讀館', routerName: 'productsList', category: 'livepen', type: 'LIVEPEN' },
        { title: '數位館', routerName: 'productsList', category: 'digital', type: 'MAGAZINE,DIGITAL' },
        { title: '下載專區', routerName: 'download', category: 'download' }
      ],
      bookTypeData: null
    }
  },
  props: {
    productTitle: {
      type: Object
    }
  },
  watch: {
    '$route.query.type' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData()
      }
    }
  },

  computed: {
    magParams () {
      if (this.productTitle.type === 'PLAN') {
        return 'MAGAZINE'
      } else {
        return this.productTitle.type
      }
    },

    navBarList () {
      let self = this

      if (!self.menuData || self.menuData.length === 0) return null

      if (self.productTitle) {
        let category = self.productTitle.type ? self.productTitle.type.toLowerCase() : null

        if (category === 'plan') {
          category = 'magazine'
        }

        return self.menuData.find((item) => item.category === category) || self.menuData[0]
      } else if (self.$route.params.category) {
        return self.menuData.find((item) => item.category === self.$route.params.category) || self.menuData[0]
      }

      return self.menuData[0]
    },
    magType () {
      let self = this
      if (self.bookTypeData && self.$route.query.category) {
        return self.bookTypeData.filter((item) => item.category_id === Number(self.$route.query.category))[0]
      } else {
        return ''
      }
    },
    magPlanType () {
      let self = this
      if (self.$route.query.type === 'PLAN' && self.magType && self.magType.items) {
        return self.magType.items.filter((item) => item.scope === self.$route.query.scope)[0]
      } else if (self.$route.query.type === 'MAGAZINE,PHYSICAL' && self.magType && self.magType.items) {
        return self.magType.items.filter((item) => item.type === 'MAGAZINE,PHYSICAL')[0]
      } else {
        return ''
      }
    },
    bookPlanType () {
      let self = this
      if (self.bookTypeData && self.$route.query.type === 'BOOK') {
        return self.bookTypeData.filter((item) => item.category_id === self.$route.query.category)[0]
      } else if (self.bookTypeData && self.$route.query.type === 'BOOK,DIGITAL') {
        return self.bookTypeData.filter((item) => item.type === 'DIGITAL')[0]
      } else {
        return ''
      }
    },
    packagePlanType () {
      let self = this
      if (self.bookTypeData && self.$route.query.type === 'PACKAGE' && (self.$route.query.category || self.$route.query.scope)) {
        let ar = [146, 136, 137, 138, 134, 139, 135, 140, 147]
        if (ar.indexOf(self.$route.query.category) > -1 || self.$route.query.scope === 'smartpen_package_series') {
          return self.bookTypeData.filter((item) => item.scope === 'smartpen_package_series')[0]
        } else {
          return self.bookTypeData.filter((item) => item.scope === 'classic_package_series')[0]
        }
      } else if (self.bookTypeData && self.$route.query.type === 'ITEM' && self.$route.query.category) {
        return self.bookTypeData.filter((item) => item.type === 'ITEM')[0]
      } else {
        return ''
      }
    },
    packsgeCildType () {
      let self = this
      if (self.packagePlanType && self.packagePlanType.items) {
        return self.packagePlanType.items.filter((item) => item.category_id === self.$route.query.category)[0]
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.$route.params.category ? this.getData() : null
  },
  methods: {
    async getData () {
      let self = this
      if (self.$route.name === 'productsList' || self.$route.name === 'detail' || self.$route.name === 'previewMagazine') {
        let path
        switch (self.$route.params.category) {
          case 'recent':
            path = '/menu/newbook'
            self.category = 'recent'
            break
          case 'magazine':
            path = '/menu/magazine'
            self.category = 'magazine'
            break
          case 'book':
            path = '/menu/book'
            self.category = 'book'
            break
          case 'package':
            path = '/menu/package'
            self.category = 'package'
            break
          case 'digital':
            path = '/menu/digital'
            self.category = 'digital'
            break
          case 'livepen':
            path = '/menu/livepen'
            self.category = 'livepen'
            break
        }
        let { data } = await axios.get(path)
        self.bookTypeData = data.menu.items
      }
    },
    toSale (id) {
      let self = this
      self.removeMenu()
      self.$router.push({ name: 'sale', params: { category: self.category }, query: { tag: id } })
    }
  }
}
</script>

<style lang="scss">
.breadcrumb-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  li {
    letter-spacing: 0.125rem;
    text-transform: uppercase;
    a {
      color: #888;
      text-decoration: none;
      transition: all 0.2s ease;
      &:hover {
        color: #333;
        text-decoration-color: #333;
      }
    }
  }
}
.breadcrumb-item + .breadcrumb-item::before {
    content: "/";
    display: inline-block;
    padding: 0 0.5rem;
    color: #d5d5d5;
}
</style>
